import React from 'react'

export function NoRecords (props) {
  return (
    <mosaic-card className='rounded-0 border-0 shadow'>
      <mosaic-card-body className='p-2 p-lg-4'>
        <div className='p-2 p-lg-3'>No records to display</div>
      </mosaic-card-body>
    </mosaic-card>
  )
}
